/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '../../../../../src/app/common/loading/loading.indicator';
import * as i2 from '../../../../../src/app/common/loading/loading.service';
var styles_LoadingIndicator = [];
export var RenderType_LoadingIndicator = i0.ɵcrt({ encapsulation: 2,
    styles: styles_LoadingIndicator, data: {} });
export function View_LoadingIndicator_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n       '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'ng2-spinner']], [[4, 'visibility',
                null]], null, null, null, null)),
        (_l()(), i0.ɵted(null, ['           \n            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'img', [['class', 'ng2-spinner-img'], ['src',
                'assets/img/loader.gif']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n       '])),
        (_l()(), i0.ɵted(null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.isLoading ? 'visible' : 'hidden');
        _ck(_v, 1, 0, currVal_0);
    });
}
export function View_LoadingIndicator_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'loading-indicator', [], null, null, null, View_LoadingIndicator_0, RenderType_LoadingIndicator)), i0.ɵdid(245760, null, 0, i1.LoadingIndicator, [i0.ElementRef, i2.LoadingService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var LoadingIndicatorNgFactory = i0.ɵccf('loading-indicator', i1.LoadingIndicator, View_LoadingIndicator_Host_0, { preLoad: 'preLoad' }, {}, []);
//# sourceMappingURL=loading.indicator.ngfactory.js.map